export default "__VITE_ASSET__DwW6kZY8__"